'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useState } from 'react';
import Tippy from '@tippyjs/react/headless';
import './Tooltip.css';
import { twMerge } from 'tailwind-merge';
/**
 * A tooltip. Provides description or context if it's not obvious what the element in question is doing.
 *
 * Useful with icons or other elements that do not have text.
 *
 * @param content
 * @param containerClassName
 * @param children
 * @param otherTippyProps See https://atomiks.github.io/tippyjs/v6/all-props/
 * @constructor
 */
export default function Tooltip({
  content,
  containerClassName,
  children,
  ...otherTippyProps
}) {
  const [opacity, setOpacity] = useState(otherTippyProps.visible ? 100 : 0);
  const [timeoutHandler, setTimeoutHandler] = useState(null);
  const durationMs = 300;
  return /*#__PURE__*/React.createElement(Tippy, _extends({
    animation: true,
    onMount: () => {
      // Cancel unmount if we are triggering the tooltip while it is fading out.
      window.clearTimeout(timeoutHandler);
      setOpacity(100);
    },
    onHide: ({
      unmount
    }) => {
      setTimeoutHandler(window.setTimeout(unmount, durationMs));
      setOpacity(0);
    },
    render: attrs => /*#__PURE__*/React.createElement("div", _extends({
      className: twMerge(`storywind-tooltip bg-black rounded text-white text-sm font-semibold px-3 py-1 transition-opacity opacity-${opacity} duration-${durationMs}`, containerClassName),
      tabIndex: -1,
      role: "tooltip"
    }, attrs), content, /*#__PURE__*/React.createElement("div", {
      className: "storywind-tooltip-arrow",
      "data-popper-arrow": ""
    }))
  }, otherTippyProps), children);
}